import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { unitColumns, unitRows, fetchUnitRows } from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";

const UnitDataTable = () => {
  const [data, setData] = useState(unitRows);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchUnitRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);

  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/del_unit/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete teacher");
        }
        setData(data.filter((item) => item.id !== id));
        toast.success("Unit deleted successfully!");
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };
  const viewLinkString = "Unit-Single";
  const editLinkString = "Unit-Edit";
  const newLinkString = "Unit-New";
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/teacher/course-chapter/unit/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/teacher/course-chapter/unit/update-unit/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle flex justify-between flex-wrap w-full lg:no-flexwrap gap-2  pb-5 lg:pb-10">
        <span>Units</span>
        <div className="linkGroup flex justify-end w-full gap-2 lg:w-fit items-center lg:gap-2 flex-wrap lg:no-flexwrap">
          {slugs && slugs.includes(newLinkString) && (
            <Link
              to="/teacher/course-chapter/unit/new"
              className="commonButton w-full sm:w-auto"
            >
              Add New
            </Link>
          )}
          <Link
            to="/teacher/course-chapter"
            className="commonButton w-full sm:w-auto"
          >
            Back
          </Link>
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={unitColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default UnitDataTable;
